import clsx from "clsx";
import React, { JSX } from "react";

type Variant = "primary" | "secondary" | "info";

type Size = "sm" | "md" | "lg" | "xl";

export const Card = ({
  variant,
  className,
  children,
  key,
  size = "md",
}: {
  variant: Variant;
  className?: string;
  children: JSX.Element[] | JSX.Element;
  size?: Size;
  key?: string | number;
}) => {
  const classes = clsx(
    {
      "max-w-[630px] sm:min-w-[350px]": size === "xl" && variant === "primary",
      "sm:min-w-[350px]": size === "sm" && variant === "primary",
    },
    {
      "w-[350px] sm:w-[350px] max-w-[630px] rounded-md bg-background p-3 md:p-6 shadow-custom":
        variant === "primary",

      "w-[350px]] sm:w-[350px] max-w-[630px] rounded-md bg-background text-white shadow-custom":
        variant === "secondary",
      "rounded-md bg-background p-6": variant === "info",
    },
    className
  );

  return (
    <div className={classes} key={key}>
      {children}
    </div>
  );
};
